import React, { useState, useRef } from 'react'
import './index.sass';
import { AuthInput } from '../../components/common/Input'
import { AccountType } from '../../components/auth'
import { ButtonRed, ButtonPink, ThemeSwitcher, ButtonGrey } from '../../components/common/Button'
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { SuccessValidator, ErrorValidator, GrayValidator } from '../../components/common/Validator'


// import { isUsernameTaken } from '../../api/auth';
import LovrFire from '../../lovrfire'

export default function Login() {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [username, setUsername] = useState("");
    const [displayName, setDisplayName] = useState("")
    const [userType, setUserType] = useState(-1);
    const [isEmailValid, setIsEmailValid] = useState(-1);
    const [isPasswordValid, setIsPasswordValid] = useState(-1);
    const [isUsernameValid, setIsUsernameValid] = useState(-1);
    const [aboveEighteen, setAboveEighteen] = useState(false);
    const [agreeTerms, setAgreeTerms] = useState(false)
    const [activateRegister, setActivateRegister] = useState(false);

    // refs
    const displayNameRef = useRef();

    // error handlers
    const [emailError, setEmailError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [usernameError, setUsernameError] = useState(false);
    const [displayNameCount, setDisplayNameCount] = useState(0);

    const history = useHistory();

    useEffect(() => {
        validateEmail(email)
    }, [email])

    useEffect(() => {
        validatePassword(password)
    }, [password])

    useEffect(() => {
        validateUsername(username, 0)
        LovrFire.firestore().collection('users').onSnapshot(v => {
            for (var i = 0; i < v.docs.length; i++) {
                if (v.docs[i].data().username === username) {
                    validateUsername(username, 1)
                    break
                }
            }
        })
    }, [username])

    useEffect(() => {
        LovrFire.firestore().collection('users').onSnapshot(v => {
            for (var i = 0; i < v.docs.length; i++) {
                if (v.docs[i].data().email === email) {
                    setIsEmailValid(2);
                    setEmailError(true);

                    break
                }
            }
        })
    }, [email])

    const validateUsername = (username, type) => {
        var expr = /^[a-zA-Z0-9.]*$/;
        if (!expr.test(username)) {
            setIsUsernameValid(3)
            setUsernameError(true)
            return;
        }
        if (type == 1) {
            setIsUsernameValid(2)
            setUsernameError(true)
        }
        else if (username.length < 3 && type == 0) {
            setIsUsernameValid(0)
            setUsernameError(true)
        }
        else {
            setIsUsernameValid(1)
            setUsernameError(false)
        }
    }

    const validateEmail = (emailField) => {
        var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (reg.test(emailField) == false) {
            setIsEmailValid(0)
            setEmailError(true);
            return false;
        }
        setIsEmailValid(1)
        setEmailError(false);
        return true;

    }

    const validatePassword = (password) => {
        var reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        if (reg.test(password) == false) {
            setIsPasswordValid(0);
            setPasswordError(true);
            return false;
        }
        setIsPasswordValid(1);
        setPasswordError(false);
        return true;
    }

    const handleOnClickLogin = (e) => {
        e.preventDefault();
        history.push('/login')
    }

    const handleOnClickSignup = async (e) => {
        e.preventDefault();

        if (userType == 0) {
            history.push({
                pathname: '/viewer-setup',
                state: { email: email, password: password, username: username, displayName: displayName, userType: userType, gender: -1, tags: [] }
            })
        } else if (userType == 1) {
            history.push({
                pathname: '/creator-setup',
                state: { email: email, password: password, username: username, displayName: displayName, userType: userType, gender: -1, tags: [] }
            })
        }

    }

    const handleSelection = (e) => {
        // console.log(e);
        setUserType(e);
    }

    const toggleAboveEighteen = () => {
        setAboveEighteen(!aboveEighteen);
    }

    const toggleAgreeTerms = () => {
        setAgreeTerms(!agreeTerms);
    }

    const handleDisplayName = (e) => {
        if (e.target.value.length <= 30) {
            setDisplayName(e.target.value);
            setDisplayNameCount(e.target.value.length);
        } else {
            displayNameRef.current.value = displayName;
        };
    }

    useEffect(() => {
        if (isUsernameValid && isPasswordValid && isUsernameValid && agreeTerms && aboveEighteen && (userType !== -1)) {
            setActivateRegister(true)
        } else {
            setActivateRegister(false)
        }
    }, [agreeTerms, aboveEighteen, isEmailValid, isPasswordValid, isUsernameValid, userType])

    return (
        <div className='lover-authCard-wrapper' >
            <ThemeSwitcher />
            <div className='lover-authCard-wrapper-header'>

                <img className='lover-logo lover-logo-size' src={require('../../assets/icons/logo.svg')} />
            </div>
            <div className="title-register">
                <h5>Create new account</h5></div>
            <div className='lover-authCard-wrapper-body'>
                <AuthInput isError={username.length > 0 && usernameError} handleInputChange={(e) => { setUsername(e.target.value) }} type='text' placeholder='Username' icon='user.svg' />
                {isUsernameValid != -1 && username.length > 0 ? 
                isUsernameValid == 0 ? <ErrorValidator text="Username is to short" /> : 
                isUsernameValid == 2 ? <ErrorValidator text="Username already taken" /> :
                isUsernameValid == 3 ? <ErrorValidator text="Only . is allowed as special char" /> : 
                <SuccessValidator text="Username available" /> : 
                <GrayValidator text="Username availability" />}

                <AuthInput refer={displayNameRef} autocapitalize={1} isError={false} handleInputChange={handleDisplayName} type='text' placeholder='Display Name' icon='user.svg' />
                <p id="displayNameCount"><span className={displayNameCount == 30 ? 'error-display-name' : ''}>{displayNameCount}</span>/30</p>
                <AuthInput isError={email.length > 0 && emailError} handleInputChange={(e) => { setEmail(e.target.value) }} type='email' placeholder='Email' icon='email.svg' />
                {isEmailValid != -1 && email.length > 0 ? isEmailValid == 0 ? <ErrorValidator text="Invalid Email" /> : isEmailValid == 2 ? <ErrorValidator text="Email already taken" /> : <div></div> : <div> </div>}
                <AuthInput isError={password.length > 0 && passwordError} handleInputChange={(e) => { setPassword(e.target.value) }} type='password' placeholder='Password' icon='lock.svg' />
                <div className="passwordhint">
                    <p>The password must contain at least 8 characters, at least 1 capital letter and at least 1 digit.</p></div>
                {isPasswordValid != -1 && password.length > 0 ? isPasswordValid == 0 ? <ErrorValidator text="Password is weak" /> : <SuccessValidator text="Password is strong" /> : <GrayValidator text="Password meter" />}

                <div className="auth-user-type">
                    <h5>Select account type</h5>
                    <div className="auth-user-type-row">
                        <AccountType
                            vActiveIcon="viewer.svg"
                            vIcon="inactiveviewer.svg"
                            vText="Lovr"
                            vDescription="As Viewer"

                            cActiveIcon="creator.svg"
                            cIcon="inactivecreator.svg"
                            cText="Loved"
                            cDescription="As Creator"

                            handleClick={handleSelection}

                        />
                    </div>
                </div>
                <div onClick={toggleAboveEighteen} className="agree-button">
                    {aboveEighteen ? <img src={require('../../assets/icons/checkbox_a.svg')}  alt="checked" /> : <img src={require('../../assets/icons/checkbox.svg')} onClick={toggleAboveEighteen} alt="unchecked" />}
                    <p>I’m at least 18 years old</p>
                </div>
                <div  onClick={toggleAgreeTerms} className="agree-button">

                    {agreeTerms ? <img src={require('../../assets/icons/checkbox_a.svg')} alt="checked" /> : <img src={require('../../assets/icons/checkbox.svg')} onClick={toggleAgreeTerms} alt="unchecked" />}
                    <p>I agree that I have read and accepted <br />the <a href="#">Terms of Use</a> and <a href="#">Privacy policy</a></p>
                </div>

                {activateRegister ? <ButtonRed text="REGISTER" icon="tick.svg" handleOnClick={handleOnClickSignup} /> : <ButtonGrey text="REGISTER" icon="tick.svg" handleOnClick={handleOnClickSignup} />}

                <ButtonPink text="LOGIN" handleOnClick={handleOnClickLogin} />

            </div>
        </div>
    )
}
